import { createPart } from "ag-grid-community";
import { fabPalette } from "../theme/fab-palette";

export const warningCellPart = createPart({
	css: `
	  .max-limit {
		color: var(--ag-warning-cell-foreground-color);
		font-weight: var(--ag-warning-cell-font-weight);
		background-color: var(--ag-warning-cell-background-color);
	  }
	`,
	params: {
		warningCellForegroundColor: fabPalette.status.warning,
		warningCellFontWeight: 600,
		warningCellBackgroundColor: "transparent",
	},
});

export const infoCellPart = createPart({
	css: `
	  .info-limit {
		color: var(--ag-info-cell-foreground-color);
		background-color: var(--ag-info-cell-background-color);
		font-weight: var(--ag-info-cell-font-weight);
	  }
	`,
	params: {
		infoCellForegroundColor: fabPalette.status.infoText,
		infoCellBackgroundColor: fabPalette.status.info,
		infoCellFontWeight: 600,
	},
});

export const shiftChipPart = createPart({
	css: `
    .custom-chip {
      display: inline-flex;
      align-items: center;
      padding: 2px 12px;
      border-radius: 16px;
      font-size: 0.8125rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      line-height: 1.5;
      cursor: default;
    }

    .ag-cell.shift-chip-D .custom-chip {
      font-weight: 800;
      color: ${fabPalette.text.light};
      background-color: ${fabPalette.shifts.day};
      border: 1px solid ${fabPalette.shifts.dayBorder};
    }

    .ag-cell.shift-chip-N .custom-chip {
      font-weight: 800;
      color: ${fabPalette.text.light};
      background-color: ${fabPalette.shifts.night};
      border: 1px solid ${fabPalette.shifts.nightBorder};
    }
  `,
	params: {},
});

export const crewChipPart = createPart({
	css: `
    .custom-chip {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 0.8125rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      line-height: 1.5;
      cursor: default;
      min-width: 24px;
      height: 24px;
    }

    .ag-cell.crew-chip-A .custom-chip {
      font-weight: 800;
      color: ${fabPalette.text.light};
      background-color: ${fabPalette.crews.A};
      border: 1px solid ${fabPalette.crews.A};
    }

    .ag-cell.crew-chip-B .custom-chip {
      font-weight: 800;
      color: ${fabPalette.text.lightMuted};
      background-color: ${fabPalette.crews.B};
      border: 1px solid ${fabPalette.crews.B};
    }

    .ag-cell.crew-chip-C .custom-chip {
      font-weight: 800;
      color: ${fabPalette.text.light};
      background-color: ${fabPalette.crews.C};
      border: 1px solid ${fabPalette.crews.C};
    }

    .ag-cell.crew-chip-D .custom-chip {
      font-weight: 800;
      color: ${fabPalette.text.light};
      background-color: ${fabPalette.crews.D};
      border: 1px solid ${fabPalette.crews.D};
    }
  `,
	params: {},
});

export const centeredHeaderPart = createPart({
	css: `
    .ag-header-cell-label {
      justify-content: center;
    }
    .ag-header-cell.left-aligned-header .ag-header-cell-label {
      justify-content: flex-start;
    }
    .ag-header-group-cell {
      border-left: 1px solid var(--ag-border-color);
    }

    .ag-header-cell.group-start {
      border-left: 1px solid var(--ag-border-color);
    }
  `,
	params: {},
});

export const inlineButtonsPart = createPart({
	css: `
    .ag-row .buttons {
      opacity: 0;
      transition: opacity 0.1s ease-in-out;
    }

    .ag-row-hover .buttons,
    .ag-row-focus .buttons,
    .ag-row-selected .buttons {
      opacity: 1;
    }
  `,
	params: {},
});
